import { render, staticRenderFns } from "./SearchCategories.vue?vue&type=template&id=99d4ca2a&"
import script from "./SearchCategories.vue?vue&type=script&lang=js&"
export * from "./SearchCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports